import PropTypes from 'prop-types';
import { Col, Pagination, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';

const ColFooterTotal = styled(Col)`
  width: 200px;
  padding: 8px 8px 8px 20px;
`;

function TableFooter({ pageData, buttons, page, onChange, total, totalPerPage, onChangeTotalPerPage }) {
  const { totalPageVa, totalPageVr } = pageData.reduce(
    (totais, benefitCooperator) => ({
      totalPageVa: totais.totalPageVa + benefitCooperator.foodVoucherValue,
      totalPageVr: totais.totalPageVr + benefitCooperator.mealVoucherValue,
    }),
    { totalPageVa: 0, totalPageVr: 0 }
  );
  return (
    <>
      <Row justify="end">
        <ColFooterTotal>{moneyFormat(totalPageVa)}</ColFooterTotal>
        <ColFooterTotal>{moneyFormat(totalPageVr)}</ColFooterTotal>
      </Row>
      <Row justify="space-between">
        <Pagination
          pageSize={totalPerPage}
          showSizeChanger={false}
          total={total}
          current={page}
          onChange={(newPage, newTotalPerPage) => {
            if (newPage !== page) onChange(newPage);
            if (totalPerPage !== newTotalPerPage) onChangeTotalPerPage(newTotalPerPage);
          }}
        />
        {buttons}
      </Row>
    </>
  );
}

TableFooter.propTypes = {
  pageData: PropTypes.arrayOf().isRequired,
  buttons: PropTypes.element.isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  totalPerPage: PropTypes.number.isRequired,
  onChangeTotalPerPage: PropTypes.func.isRequired,
};

export default TableFooter;
